import { FormControlLabel, Switch, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'

interface Props {
  value: boolean
  onChange: (value: boolean) => void
}

export const FullViewSwitch = ({ value, onChange }: Props) => {
  const { t } = useTranslate()

  return (
    <FormControlLabel
      control={
        <Switch
          checked={value}
          onChange={(_, val) => {
            onChange(val)
          }}
          data-cy='full-view-switch'
        />
      }
      label={<Typography variant='caption'>{t('fullView', 'Full view')}</Typography>}
    />
  )
}
